import { intervalToDuration, parseISO } from 'date-fns'
import { useEffect, useState } from 'react'

import { isValidDuration } from 'core/utils/date'
import { padNumber } from 'core/utils/number'

export function calculateCountdown(endISODate: string) {
  const now: Date = new Date()
  const endDate = parseISO(endISODate)
  const duration: Duration =
    now < endDate ? intervalToDuration({ start: now, end: endDate }) : { hours: 0, minutes: 0 }

  const isDurationGreaterThanOneDay = !(
    !isValidDuration(duration, 'years') &&
    !isValidDuration(duration, 'months') &&
    !isValidDuration(duration, 'weeks') &&
    !isValidDuration(duration, 'days')
  )

  if (isDurationGreaterThanOneDay) {
    throw new Error('Invalid countdown deadline: should be in less than 24 hours')
  }

  if (duration.hours === undefined || duration.minutes === undefined) {
    throw new Error('Invalid date')
  }

  return `${padNumber(duration.hours, 2, '0')}:${padNumber(duration.minutes, 2, '0')}`
}

export function useCountdown(countdownDeadline: string) {
  const [countdown, setCountdown] = useState<string>('--:--')

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(calculateCountdown(countdownDeadline))
    }, 1000)

    return () => clearInterval(timer)
  })

  return { countdown, countdownHasFinished: countdown === '00:00' }
}
